import { render, staticRenderFns } from "./GlErrorText.vue?vue&type=template&id=8b7caf2a&scoped=true&"
import script from "./GlErrorText.vue?vue&type=script&lang=js&"
export * from "./GlErrorText.vue?vue&type=script&lang=js&"
import style0 from "./GlErrorText.vue?vue&type=style&index=0&id=8b7caf2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7caf2a",
  null
  
)

export default component.exports